import LearnVisualFrame from "./LearnVisualFrame";
import p from "./visualPalette";

export default function ResourceReserveVisual({ title, takeaway, caption, data = {} }) {
  const resources = data.resourceClasses || ["Measured", "Indicated"];
  const reserves = data.reserveClasses || ["Proven", "Probable"];
  const bridgeLabel = data.bridgeLabel || "Technical + economic evaluation and applicable modifying factors";

  return (
    <LearnVisualFrame title={title} takeaway={takeaway} caption={caption} size="large">
      <svg viewBox="0 0 820 350" role="img" aria-label="Measured and Indicated resources can feed technical and economic evaluation for reserves, while Inferred resources are shown separately as lower-confidence material not directly converted to reserves in this visual.">
        <rect x="44" y="42" width="230" height="170" rx="10" fill="#fff" stroke={p.line} />
        <text x="159" y="76" textAnchor="middle" fontSize="15" fontWeight="900" fill={p.ink}>Mineral Resources</text>
        {resources.map((label, index) => (
          <g key={label}>
            <rect x="82" y={104 + index * 48} width="154" height="34" rx="17" fill={index === 0 ? p.goldWash : "rgba(34,35,37,0.04)"} stroke={p.softLine} />
            <text x="159" y={126 + index * 48} textAnchor="middle" fontSize="13" fontWeight="850" fill={p.ink}>{label}</text>
            <path d={`M236 ${121 + index * 48} H326`} stroke={p.gold} strokeWidth="2.5" />
          </g>
        ))}
        <path d="M326 121 V169" stroke={p.gold} strokeWidth="2.5" />
        <path d="M326 145 H370" stroke={p.gold} strokeWidth="2.5" />
        <path d="M370 145 l-10 -7 v14 z" fill={p.gold} />

        <rect x="378" y="88" width="176" height="114" rx="8" fill={p.goldWash} stroke={p.gold} />
        <text x="466" y="118" textAnchor="middle" fontSize="13" fontWeight="900" fill={p.ink}>Evaluation</text>
        <foreignObject x="398" y="130" width="136" height="54">
          <div xmlns="http://www.w3.org/1999/xhtml" style={{ fontSize: 12, lineHeight: 1.3, color: p.muted, textAlign: "center", fontWeight: 750 }}>
            {bridgeLabel}
          </div>
        </foreignObject>
        <path d="M554 145 H610" stroke={p.gold} strokeWidth="2.5" />
        <path d="M610 145 l-10 -7 v14 z" fill={p.gold} />

        <rect x="620" y="42" width="156" height="170" rx="10" fill="#fff" stroke={p.line} />
        <text x="698" y="76" textAnchor="middle" fontSize="15" fontWeight="900" fill={p.ink}>Mineral Reserves</text>
        {reserves.map((label, index) => (
          <g key={label}>
            <rect x="646" y={110 + index * 48} width="104" height="34" rx="17" fill={p.goldWash} stroke={p.gold} />
            <text x="698" y={132 + index * 48} textAnchor="middle" fontSize="13" fontWeight="900" fill={p.ink}>{label}</text>
          </g>
        ))}

        <rect x="44" y="250" width="230" height="84" rx="10" fill="rgba(34,35,37,0.035)" stroke={p.softLine} />
        <text x="159" y="282" textAnchor="middle" fontSize="13" fontWeight="900" fill={p.ink}>Inferred</text>
        <text x="159" y="310" textAnchor="middle" fontSize="12" fontWeight="750" fill={p.muted}>Lower-confidence resource category</text>
        <path d="M290 292 H515" stroke={p.softLine} strokeWidth="2" strokeDasharray="5 5" />
        <text x="535" y="296" fontSize="12" fontWeight="800" fill={p.muted}>Not shown as directly converting to reserves</text>
      </svg>
    </LearnVisualFrame>
  );
}
